import React, { Fragment } from 'react';
import { Row } from 'reactstrap';
import { Menu } from 'react-feather';
import RightHeader from '../../header/rightbar';
import { useSidebar } from '../../sidebar/SidebarContext';

const Header = () => {
  const { toggle: toggleSidebar } = useSidebar();

  return (
    <Fragment>
      <div className="page-header">
        <Row className="header-wrapper m-0">
          <div className="header-logo-wrapper d-lg-none">
            <div
              className="toggle-sidebar"
              onClick={toggleSidebar}
              role="button"
              aria-label="Toggle sidebar"
              style={{ cursor: 'pointer' }}
            >
              <Menu className="status_toggle middle sidebar-toggle" />
            </div>
          </div>
          <RightHeader internalDashboard={true} />
        </Row>
      </div>
    </Fragment>
  );
};

export default Header;
